import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useTemporaryBooleanState } from '@/hooks';
import { CheckSmallIcon, LinkIcon } from '@/icons';
import { Button } from '@/ui_v3';
import { cn } from '@/utils/tailwind.util';
interface LinkCopySectionProps {
  url: string;
  /** 복사 시도 결과를 넘긴다. 공유 수단 계측은 모달이 소유한다. */
  onCopied?: (succeeded: boolean) => void;
  /**
   * 비식별화 모드에서 링크 행을 흐린다.
   *
   * 이 섹션은 입장 코드·QR 을 담은 `bg-neutral` 컨테이너 **밖**의 형제라 그 컨테이너의
   * blur 를 못 받는다. 자체 blur 가 없으면 오버레이의 backdrop-blur 만 걸려 혼자 덜
   * 흐려지고, 버튼 테두리가 그대로 드러난다.
   */
  obscured?: boolean;
}
export const LinkCopySection = ({
  url,
  onCopied,
  obscured
}: LinkCopySectionProps) => {
  const [isLinkCopied, setIsLinkCopied] = useTemporaryBooleanState(false, 2000);
  const {
    t
  } = useTranslation(['common']);
  return <div className={cn('flex w-full min-w-0 flex-shrink-0 items-center gap-sm', obscured && 'blur-[4px]')} data-sentry-component="LinkCopySection" data-sentry-source-file="LinkCopySection.tsx">
      <div className="flex h-[48px] min-w-0 flex-1 items-center truncate rounded-sm border border-alternative bg-alternative px-sm text-body-lg-medium">
        <p className="truncate">{url}</p>
      </div>
      <CopyToClipboard text={url} onCopy={(_text, succeeded) => {
      logger.track('share_link_copy', {
        link: url
      });
      // 클립보드 권한 거부·API 실패도 onCopy 로 들어온다. 성공으로 뭉치면
      // 새 이벤트의 result 가 항상 success 라 필드가 무의미해진다.
      onCopied?.(succeeded);
      if (succeeded) setIsLinkCopied(true);
    }} data-sentry-element="CopyToClipboard" data-sentry-source-file="LinkCopySection.tsx">
        <Button className="shrink-0" variant="outlined" intent="alternative" leftSlot={isLinkCopied ? <CheckSmallIcon /> : <LinkIcon />} data-sentry-element="Button" data-sentry-source-file="LinkCopySection.tsx">
          <span>
            {isLinkCopied ? t('global.duplicate.complete') : t('shareModal.copyLink.button')}
          </span>
        </Button>
      </CopyToClipboard>
    </div>;
};